import { useState } from 'react';
import {
  Stack,
  HStack,
  Box,
  Input,
  Button,
  Icon,
  Flex,
  Tag,
} from '@chakra-ui/react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { ControllerRenderProps } from 'react-hook-form';

interface CreatableTextInputProps {
  field: ControllerRenderProps<any, any>;
  placeholder?: string;
}

export default function CreatableTextInput({ 
  field, 
  placeholder = "Type and press Enter or click + to add...",
}: CreatableTextInputProps) {
  const [inputValue, setInputValue] = useState('');
  
  const handleAddValue = () => {
    if (inputValue.trim() && !field.value?.includes(inputValue.trim())) {
      const newValues = [...(field.value || []), inputValue.trim()];
      field.onChange(newValues);
      setInputValue('');
    }
  };

  const handleRemoveValue = (valueToRemove: string) => {
    const newValues = field.value?.filter((value: string) => value !== valueToRemove) || [];
    field.onChange(newValues);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddValue();
    }
  };

  return (
    <Stack width={'full'} gap={3}>
      <Flex width={'full'} gap={2}>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          flex={1}
        />
        <Button
          size="sm"
          onClick={handleAddValue}
          disabled={!inputValue.trim()}
        >
          <Icon as={PlusIcon} mr={2} />
          Add
        </Button>
      </Flex>

      {field.value && field.value.length > 0 && (
        <Box>
          <HStack gap={2} flexWrap="wrap">
            {field.value.map((value: string, index: number) => (
              <Tag.Root
                key={index}
                size='lg'
              >
                <Tag.Label>{value}</Tag.Label>
                <Tag.EndElement onClick={() => handleRemoveValue(value)}>
                  <Tag.CloseTrigger />
                </Tag.EndElement>
              </Tag.Root>
            ))}
          </HStack>
        </Box>
      )}
    </Stack>
  );
}
